"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformModule = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformModulePinConnection_1 = require("./TransformModulePinConnection");
class TransformModule extends TransformObject_1.TransformObject {
    constructor(parent, props, component, projectModule) {
        super(parent, {
            modProps: props,
            component,
            projectModule,
            pinConnections: new Set(),
        }, `${parent.deduplicationKey}::mod::${props.ref}`, new Set([TransformModulePinConnection_1.TransformModulePinConnection]));
        projectModule.registerInstance(this);
    }
    add(child) {
        this.assertCanAdd(child);
        this._sharedData.pinConnections.add(child);
    }
    get dependencies() {
        return [this._sharedData.component];
    }
    get creates() {
        return [this._sharedData.projectModule];
    }
    compile() {
        const pinNets = Object.fromEntries(Array.from(this._sharedData.pinConnections).map((child) => [child.compiled.connection.pinRef, child.compiled.netRef.strCast()]));
        return {
            layer: 'F',
            ...this._sharedData.modProps,
            componentRef: this._sharedData.component.compiled.name,
            pinNets,
        };
    }
}
exports.TransformModule = TransformModule;
//# sourceMappingURL=TransformModule.js.map